import React, { Fragment, useEffect } from "react";
import { withRouter } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { Box } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import InformacionPredio from "./InformacionPredio";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import { useDispatch, useSelector } from "react-redux";
import { obtenerDatosPredioHistorial, obtenerTodosDatosClienteInformacionPredios, obtenerTodosDatosClienteInformacionPrediosByRazon, obtenerTodosDatosClienteInformacionPrediosBySocio } from "../../../redux/DucksUsuarioAgricola/DatosPredioDucks";
import { DataGrid, useGridApiRef } from '@mui/x-data-grid';
import estilos from "./PanelInformacionPredio.module.css"
import Tooltip from '@mui/material/Tooltip';
const PanelInformacionPredio = (props) => {
  const dispatch = useDispatch();


  const dataAsociado = useSelector((store) => store.InformacionValidaApi.data.data);
  const [value, setValue] = React.useState(0);
  const [historial, setHistorial] = React.useState([]);

  const [dataCliente, setDataCliente] = React.useState([]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const dataTableHead = [/*"ID",*/ "NO. CLIENTE", "NOMBRE"/* ,"NOMBRE DEL PREDIO" */];


  const [numPredioA, setNumPredioA] = React.useState('');
  const [open, setOpen] = React.useState(false);

  const [numSocio, setNumSocio] = React.useState('');
  const [openSocio, setOpenSocio] = React.useState(false);

  const [razonSocial, setRazonSocial] = React.useState('');
  const [openNombre, setOpenNombre] = React.useState(false);

  const [datosPredio, setDatosPredio] = React.useState([]);
  const [descuentos, setDescuentos] = React.useState([]);

  React.useEffect(async () => {
    if (numPredioA != null && numPredioA != undefined && numPredioA != '') {
      const timer = setTimeout(async () => {
        let res = await dispatch(obtenerDatosPredioHistorial(numPredioA))
        setHistorial(res.payload)
      }, 1000);
      return () => clearTimeout(timer)
    }
    if (razonSocial != null && razonSocial != undefined && razonSocial != '') {
      const timer = setTimeout(async () => {
        let result = await dispatch(obtenerTodosDatosClienteInformacionPrediosByRazon(razonSocial))
        setDataCliente(result.payload)
      }, 1000);
      return () => clearTimeout(timer)
    }
    if (numSocio != null && numSocio != undefined && numSocio != '') {
      const timer = setTimeout(async () => {
        let result = await dispatch(obtenerTodosDatosClienteInformacionPrediosBySocio(numSocio))
        setDataCliente(result.payload)
      }, 1000);
      return () => clearTimeout(timer)

    }
  }, [numPredioA, numSocio, razonSocial])

  const handlerSeleccionNumPredio = (value) => {
    if (value === null) { setNumPredioA(""); }
    if (razonSocial == '') {
      setRazonSocial(value?.cliente?.nombrerazonsocial)
      setNumSocio(value?.cliente?.numerosocio)
      setDatosPredio(value)
      let filas = []
      console.log('los datos de datos maguey es ', value)
      for (const i in value.datosmaguey) {
        let { ...datas } = value.datosmaguey[i]
        datas.id = uuidv4()
        filas.push(datas)
      }
      setRows(filas)
      let descuento = []
      for (const i in value.datosmaguey) {
        let { ...maguey } = value.datosmaguey[i]
        for (const j in maguey.datosmagueyhistorico) {
          let { ...filadecuento } = maguey.datosmagueyhistorico[j]
          filadecuento.id = uuidv4()
          filadecuento.numerosocio = value.cliente.numerosocio
          descuento.push(filadecuento)
        }
      }
      setDescuentos(descuento)

      let filasGuias = []
      for (const i in value.guias) {
        let { ...guia } = value.guias[i]
        guia.id = uuidv4()
        let estatusguia = ''
        if (guia.esactiva == false && guia.isnoocupada == false) estatusguia = 'Guía ocupada por descuento'
        else if (guia.esactiva == true && guia.isnoocupada == false) estatusguia = 'Guía disponible para descuento'
        else if (guia.esactiva == false && guia.isnoocupada == true) estatusguia = 'Guía inhabilitada por edición de datos'
        guia.estatus = estatusguia
        filasGuias.push(guia)
      }

      let ordenado = filasGuias.sort((a, b) => a.idguias - b.idguias);
      setRowsGuias(ordenado)
    }


    if (razonSocial != '' && numSocio != '') {
      setDatosPredio(value)
      setRazonSocial(value?.cliente?.nombrerazonsocial)
      setNumSocio(value?.cliente?.numerosocio)
      let filas = []
      for (const i in value.datosmaguey) {
        let { ...datas } = value.datosmaguey[i]
        datas.id = uuidv4()
        filas.push(datas)
      }
      setRows(filas)
      let descuento = []
      for (const i in value.datosmaguey) {
        let { ...maguey } = value.datosmaguey[i]
        for (const j in maguey.datosmagueyhistorico) {
          let { ...filadecuento } = maguey.datosmagueyhistorico[j]
          filadecuento.id = uuidv4()
          filadecuento.numerosocio = numSocio
          descuento.push(filadecuento)
        }
      }
      setDescuentos(descuento)

      let filasGuias = []
      for (const i in value.guias) {
        let { ...guia } = value.guias[i]
        guia.id = uuidv4()
        let estatusguia = ''
        if (guia.esactiva == false && guia.isnoocupada == false) estatusguia = 'Guia ocupada por descuento'
        else if (guia.esactiva == true && guia.isnoocupada == false) estatusguia = 'Guia disponible para descuento'
        else if (guia.esactiva == false && guia.isnoocupada == true) estatusguia = 'Guia inhabilitada por edición de datos'
        guia.estatus = estatusguia
        filasGuias.push(guia)
      }

      let ordenado = filasGuias.sort((a, b) => a.idguias - b.idguias);
      setRowsGuias(ordenado)
    }
  };

  const handlerSeleccionRazon = (value) => {
    if (value === null) {
      setRazonSocial("");
    }
    setRazonSocial(value?.nombrerazonsocial)
    setNumSocio(value?.numerosocio)
    setHistorial(value?.datospredio)
    setOpen(true)

    /*setDatosPredio(value)
    let filas = []
    for (const i in value.datosmaguey) {
      let { ...datas } = value.datosmaguey[i]
      datas.id = uuidv4()
      filas.push(datas)
    }
    setRows(filas)
    let descuento = []
    for (const i in value.datosmaguey) {
      let { ...maguey } = value.datosmaguey[i]
      for (const j in maguey.datosmagueyhistorico) {
        let { ...filadecuento } = maguey.datosmagueyhistorico[i]
        filadecuento.id = uuidv4()
        filadecuento.numerosocio = value.cliente.numerosocio
        descuento.push(filadecuento)
      }
    }
    setDescuentos(descuento)*/
  };

  const handlerSeleccionSocio = (value) => {
    if (value === null) {
      setNumSocio("");
    }
    setRazonSocial(value?.nombrerazonsocial)
    setNumSocio(value?.numerosocio)
    setHistorial(value?.datospredio)
    setOpen(true)
  };

  const [rows, setRows] = React.useState([]);
  const columns = [{
    field: 'nombrecomun', headerName: 'Nombre Común', headerAlign: 'center', width: 200, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.catalogomaguey.nombrecomun}`} arrow>
        <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.catalogomaguey.nombrecomun} `}</label>
      </Tooltip>
  },
  {
    field: 'nombrecientifico', headerName: 'Nombre Cientifico', headerAlign: 'center', width: 200, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico}`} arrow>
        <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.catalogomaguey.catalogomagueynombrecientifico.nombrecientifico} `}</label>
      </Tooltip>
  },
  {
    field: 'sistemaplantacion', headerName: 'Situación de manejo', headerAlign: 'center', width: 200, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.sistemaplantacion}`} arrow>
        <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.sistemaplantacion} `}</label>
      </Tooltip>
  },
  {
    field: 'numeroplantasregistro', headerName: 'Cantidad inicial', headerAlign: 'center', width: 160, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.numeroplantasregistro}`} arrow>
        <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.numeroplantasregistro} `}</label>
      </Tooltip>
  },
  {
    field: 'numeroplantas', headerName: 'Existencia', headerAlign: 'center', width: 150, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.numeroplantas}`} arrow>
        <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.numeroplantas} `}</label>
      </Tooltip>
  },
  {
    field: 'edad', headerName: 'Edad Actual', headerAlign: 'center', width: 150, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.edad}`} arrow>
        <label style={{ background: params.row.isediciondatos ? '#A0FFA5' : '', height: '100%', width: '110%' }}>{`${params.row.edad} `}</label>
      </Tooltip>
  }]

  const columnsDescuento = [{
    field: 'identificador', headerName: 'Guia', headerAlign: 'center', width: 200, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.constancia.identificador}`} arrow>
        <label >{`${params.row.constancia.identificador} `}</label>
      </Tooltip>
  },
  {
    field: 'numerosocio', headerName: 'Cliente Envia', headerAlign: 'center', width: 150, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.numerosocio}`} arrow>
        <label >{`${params.row.numerosocio} `}</label>
      </Tooltip>
  },
  {
    field: 'receptor', headerName: 'Cliente Recibe', headerAlign: 'center', width: 150, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.descuentomaguey?.receptor}`} arrow>
        <label >{`${params.row.descuentomaguey?.receptor} `}</label>
      </Tooltip>
  },
  {
    field: 'numeroplantasregistro', headerName: 'Cantidad Plantas', headerAlign: 'center', width: 150, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row?.numeroplantasregistro}`} arrow>
        <label >{`${params.row?.numeroplantasregistro} `}</label>
      </Tooltip>
  },
  {
    field: 'descuento', headerName: 'Cantidad Descontada', headerAlign: 'center', width: 160, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row?.descuentomaguey?.descuento}`} arrow>
        <label >{`${params.row?.descuentomaguey?.descuento} `}</label>
      </Tooltip>
  },
  {
    field: 'tapada', headerName: 'No. Tapada', headerAlign: 'center', width: 150, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row?.descuentomaguey?.tapada}`} arrow>
        <label >{`${params.row?.descuentomaguey?.tapada} `}</label>
      </Tooltip>
  },
  {
    field: 'inspector', headerName: 'Inspector', headerAlign: 'center', width: 150, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.descuentomaguey?.inspector}`} arrow>
        <label >{`${params.row.descuentomaguey?.inspector} `}</label>
      </Tooltip>
  },
  {
    field: 'fecha', headerName: 'Fecha', headerAlign: 'center', width: 150, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.descuentomaguey?.fechadescuento?.substring(0, 10)}`} arrow>
        <label >{`${params.row.descuentomaguey?.fechadescuento?.substring(0, 10)} `}</label>
      </Tooltip>
  }]
  const [rowsguias, setRowsGuias] = React.useState([]);

  const columnsGuias = [{
    field: 'identificador', headerName: 'Identificador', headerAlign: 'center', width: 200, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.identificador}`} arrow>
        <label>{`${params.row.identificador} `}</label>
      </Tooltip>
  },
  {
    field: 'fechacreacion', headerName: 'Fecha de creación', headerAlign: 'center', width: 250, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row?.fechacreacion?.substring(0, 10)}`} arrow>
        <label >{`${params.row?.fechacreacion?.substring(0, 10)} `}</label>
      </Tooltip>
  },
  {
    field: 'usuariocreador', headerName: 'Usuario generador', headerAlign: 'center', width: 350, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.usuariocreador}`} arrow>
        <label>{`${params.row.usuariocreador} `}</label>
      </Tooltip>
  },
  {
    field: 'estatus', headerName: 'Estatus', headerAlign: 'center', width: 320, sortable: false,
    renderCell: (params) =>
      <Tooltip title={`${params.row.estatus}`} arrow>
        <label>{`${params.row.estatus} `}</label>
      </Tooltip>
  }]
  //const idPredio = (number, len) => "0".repeat(len - number.toString().length) + number.toString();

  const idPredio = (input, len) => {
    const number = parseInt(input, 10);
    const paddedNumber = number.toString().padStart(len, "0");
    return paddedNumber;
  };

  return (
    <Fragment>
      <br />
      <div className="container mt-4">
        <div className="row">
          <h4 className={`${estilos.labelEspecial} text-center `}>Información de Predios</h4><br />
          <div className="text-end"> <button style={{ borderRadius: '6px', padding: '10px' }} className='btn-success' onClick={e => window.location.reload(true)}>Limpiar datos</button><br /></div>
          <div className="col-md-4">
            <label className="form-label"></label>
            <label className="form-label">No. Predio "A":</label>
            <Autocomplete
              freeSolo open={open}
              inputValue={numPredioA !== null && numPredioA !== undefined ? numPredioA : ""}
              onOpen={() => { if (numPredioA) { setOpen(true); } }}
              onClose={() => setOpen(false)}
              onInputChange={(e, value) => {
                setNumPredioA(value);
                if (!value) { setOpen(false); }
              }}
              onChange={(event, value) => { handlerSeleccionNumPredio(value); }}
              options={historial ? historial : []}

              getOptionLabel={(opcion) =>
                opcion ? idPredio(opcion.iddatospredio, 5) + "" : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, }}
                  size="small" style={{ background: "white" }} fullWidth
                  onKeyDown={e => { !open && e.key === "Enter" && e.stopPropagation(); }}
                />
              )}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label"></label>
            <label className="form-label">Nombre o razón social:</label>
            <Autocomplete
              freeSolo open={openNombre}
              inputValue={razonSocial !== null && razonSocial !== undefined ? razonSocial : ""}
              onOpen={() => { if (razonSocial) { setOpenNombre(true); } }}
              onClose={() => setOpenNombre(false)}
              onInputChange={(e, value) => {
                setRazonSocial(value);
                if (!value) { setOpenNombre(false); }
              }}
              onChange={(event, value) => { handlerSeleccionRazon(value); }}
              options={dataCliente ? dataCliente : []}

              getOptionLabel={(opcion) =>
                opcion ? opcion?.nombrerazonsocial + "" : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, }}
                  size="small" style={{ background: "white" }} fullWidth
                  onKeyDown={e => { !openNombre && e.key === "Enter" && e.stopPropagation(); }}
                />
              )}
            />
          </div>
          <div className="col-md-4">
            <label className="form-label"></label>
            <label className="form-label">Numero de socio:</label>
            <Autocomplete
              freeSolo open={openSocio}
              inputValue={numSocio !== null && numSocio !== undefined ? numSocio : ""}
              onOpen={() => { if (numSocio) { setOpenSocio(true); } }}
              onClose={() => setOpenSocio(false)}
              onInputChange={(e, value) => {
                setNumSocio(value);
                if (!value) { setOpenSocio(false); }
              }}
              onChange={(event, value) => { handlerSeleccionSocio(value); }}
              options={dataCliente ? dataCliente : []}

              getOptionLabel={(opcion) =>
                opcion ? opcion?.numerosocio + "" : ""
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  variant="outlined"
                  sx={{ "& legend": { display: "none" }, "& fieldset": { top: 0 }, }}
                  size="small" style={{ background: "white" }} fullWidth
                  onKeyDown={e => { !openSocio && e.key === "Enter" && e.stopPropagation(); }}
                />
              )}
            />
          </div>
          {(numPredioA?.length > 0 || numSocio?.length > 0 || razonSocial?.length > 0) &&
            <div className="row mt-5" >
              <div className="col-md-4"><label><b>Nombre de Predio:</b> {datosPredio?.nombrepredio}</label> </div>
              <div className="col-md-4"><label><b>Fecha de registro:</b> {datosPredio?.fecharegistro?.substring(0, 10)}</label> </div>
              <div className="col-md-4"><label><b>Tipo de registro:</b> {datosPredio?.tipoguia}</label></div>
              <div className="col-md-4 mt-3"><label><b>Superficie:</b> {datosPredio?.superficiehectarea}</label></div>
              <div className="col-md-4 mt-3"><label><b>Longitud:</b> {datosPredio?.longitudoeste}</label></div>
              <div className="col-md-4 mt-3"><label><b>Latitud:</b> {datosPredio?.latitudnorte}</label></div>
            </div>}
          {(numPredioA?.length > 0 || numSocio?.length > 0 || razonSocial?.length > 0) &&
            <div className='col-12 mt-5'>
              <h3 className="text-center" style={{ background: '#81810e', borderRadius: '20px', color: 'white' }}>Datos del maguey</h3>
              <div style={{ height: (130 + (rows?.length * 50)), width: '100%', color: 'black' }}>
                <DataGrid
                  rows={rows}
                  columns={columns}
                  disableColumnMenu
                  sx={{
                    boxShadow: 0,
                    color: 'black',
                    border: 0,
                    '& .MuiDataGrid-cell': {
                      display: 'block',
                      position: 'relative',
                      textAlign: 'center',
                    },
                  }}
                />
              </div>
            </div>}
          {(numPredioA?.length > 0 || numSocio?.length > 0 || razonSocial?.length > 0) &&
            <div className='col-12 mt-5'>
              <h3 className="text-center" style={{ background: '#81810e', borderRadius: '20px', color: 'white' }}>Descuentos</h3>
              <div style={{ height: (130 + (descuentos?.length * 50)), width: '100%', color: 'black' }}>
                <DataGrid
                  rows={descuentos}
                  columns={columnsDescuento}
                  disableColumnMenu
                  sx={{
                    boxShadow: 0,
                    color: 'black',
                    border: 0,
                    '& .MuiDataGrid-cell': {
                      display: 'block',
                      position: 'relative',
                      textAlign: 'center',
                    },
                  }}
                />
              </div>
            </div>}
          {(numPredioA?.length > 0 || numSocio?.length > 0 || razonSocial?.length > 0) &&
            <div className='col-12 mt-5'>
              <h3 className="text-center" style={{ background: '#81810e', borderRadius: '20px', color: 'white' }}>Información de guías</h3>
              <div style={{ height: (130 + (rowsguias?.length * 50)), width: '100%', color: 'black' }}>
                <DataGrid
                  rows={rowsguias}
                  columns={columnsGuias}
                  disableColumnMenu
                  sx={{
                    boxShadow: 0,
                    color: 'black',
                    border: 0,
                    '& .MuiDataGrid-cell': {
                      display: 'block',
                      position: 'relative',
                      textAlign: 'center',
                    },
                  }}
                />
              </div>
            </div>}
        </div>

      </div>

      {/*<div className="container">
        <div className="bg-light p-2 rounded ms-5">
          <Box sx={{ width: "100%" }}>
            <Tabs value={value} onChange={handleChange} centered>
              <Tab label="Predios" />

            </Tabs>
          </Box>

          <div className="pt-2">
            {value === 0 && (
              <InformacionPredio
                dataValues={dataAsociado ? dataAsociado : []}
                dataPredio={dataAsociado ? dataAsociado : []}
                dataTableHead={dataTableHead}
              ></InformacionPredio>
            )}
          </div>
        </div>
            </div>*/}
    </Fragment>
  );
}

export default withRouter(PanelInformacionPredio)